//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface UserResponse {
    id: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dnvName?: string | undefined;
    userName?: string | undefined;
    veracityId?: string | undefined;
    email?: string | undefined;
    organizationId: number;
    termsOfUseAccepted: boolean;
    isEnabled: boolean;
    veracityMessageCount: number;
    organization?: OrganizationSimple | undefined;
    role?: UserRoleSimple | undefined;
}

export interface OrganizationBase {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    isDefault: boolean;
    subscriptionExpirationDate?: Date | undefined;
    pricePlanId: number;
    pricePlanName?: string | undefined;
    hasAccessToApi: boolean;
    createdAt: Date;
}

export interface OrganizationSimple extends OrganizationBase {
    maxCalculationRequests: number;
    currentCalculationRequestsCount: number;
    maxParallelCalculations: number;
    currentParallelCalculationsCount: number;
}

export interface UserRoleSimple {
    id: number;
    name?: string | undefined;
}

export interface ApiKeySimple {
    key?: string | undefined;
    isActive: boolean;
    expirationDate?: Date | undefined;
}

export interface GetAllSelectionOptionsResponse {
    isoBaList?: SelectListItem[] | undefined;
    systemConfigurationsList?: SelectListItem[] | undefined;
    runOptionsList?: SelectListItem[] | undefined;
    wholesaleMarketLibraryDatasets?: SelectListItem[] | undefined;
    finansesLibraryDatasets?: SelectListItem[] | undefined;
    taxDepreciationTypes?: SelectListItem[] | undefined;
    pvProductionSoftwareTypes?: SelectListItem[] | undefined;
}

export interface SelectListItem {
    disabled: boolean;
    group?: SelectListGroup | undefined;
    selected: boolean;
    text?: string | undefined;
    value?: string | undefined;
}

export interface SelectListGroup {
    disabled: boolean;
    name?: string | undefined;
}

export interface PricePlanSimple {
    id: number;
    name?: string | undefined;
    price?: string | undefined;
}

export interface ExternalApiKeySimple {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    key?: string | undefined;
    type: KeyTypes;
    typeString?: string | undefined;
    expirationDate?: Date | undefined;
}

export enum KeyTypes {
    Src = 0,
    SolarFarmer = 1,
}

export interface AddExternalApiKeyRequest {
    name?: string | undefined;
    description?: string | undefined;
    key?: string | undefined;
    type: KeyTypes;
    expirationDate?: Date | undefined;
}

/** A definition of updating entity property. */
export interface UpdatePropertyRequest {
    /** Property name */
    propertyName?: string | undefined;
    /** A new value to update.  */
    propertyValue?: any | undefined;
}

export interface DatasetSimple {
    id: number;
    name?: string | undefined;
    isDefault: boolean;
    isLocked: boolean;
    isArchive: boolean;
    createdBy?: string | undefined;
    createdAt: Date;
    modifiedBy?: string | undefined;
    modifiedAt?: Date | undefined;
}

export interface FinancesSimple extends DatasetSimple {
    capacityAugmentationFileId?: number | undefined;
    capacityAugmentationFileName?: string | undefined;
    taxDepreciationType: TaxDepreciationTypes;
    dcSide: number;
    powerConversionSystem: number;
    gridManagementSystem: number;
    lvXmerAndSwitchgear: number;
    preventativeMaintenanceAndDispatchCost: number;
    capacityLongTermServiceAgreement: number;
    esomCostEscalationRate: number;
    pvModuleEquipment: number;
    pcsInvertersAndAssociatedControls: number;
    pvEquipmentEnggAndConstruction: number;
    pvlvTransformer: number;
    pvFixedOMCost: number;
    pvomCostEscalationRate: number;
    wtgFoundations: number;
    wtgSupplyAndOptions: number;
    wtgInstallation: number;
    collectionSystem: number;
    controlSystem: number;
    windLVXmers: number;
    windFixedOMCost: number;
    windOMCostEscalationRates: number;
    landLeaseAndAcquisition: number;
    siteAndPublicRoads: number;
    buildings: number;
    directInterconnectionCost: number;
    systemUpgrades: number;
    projectDevelopment: number;
    projectManagement: number;
    contingencyAndOverhead: number;
    constructionManagementAndEngg: number;
    federalITCRateOfInstalledCost: number;
    taxRate: number;
    salesTaxRate: number;
    debtForBESSFinancing: number;
    debtFinancingRate: number;
    debtFinancingTerm: number;
    discountRate: number;
    equipmentInsuranceFee: number;
    ownerOrganizationName?: string | undefined;
    linkedScenarios?: ScenarioSimple[] | undefined;
}

export enum TaxDepreciationTypes {
    NotSet = 0,
    Macrs7Years = 1,
    Macrs5Years = 2,
    NoMacrs = 3,
    UserDefiniedMacrs = 4,
}

export interface ScenarioSimpleBase {
    id: number;
    projectId: number;
    projectName?: string | undefined;
    name?: string | undefined;
    createdAt: Date;
    modifiedAt: Date;
    yearsToRun: RunOptions;
    yearsToRunString?: string | undefined;
    systemConfiguration: SystemConfigurations;
    systemConfigurationString?: string | undefined;
    startYear: number;
    endYear?: number | undefined;
    tag: ScenarioTags;
    selectedRunYears?: number[] | undefined;
}

export interface ScenarioSimple extends ScenarioSimpleBase {
    interconnectionCapacity?: number | undefined;
    acLineEfficiency?: number | undefined;
    acMainTransformerEfficiency?: number | undefined;
    hasAnyInputFile: boolean;
    state: CalculationStates;
    stateString?: string | undefined;
    errors?: string[] | undefined;
    errorCode?: string | undefined;
    result?: ShortResult | undefined;
    calculationStartDate?: Date | undefined;
    calculationEndDate?: Date | undefined;
    calculationProgress?: number | undefined;
    createdBy?: string | undefined;
    sourceScenarioId: number;
    wholesaleMarketPriceId?: number | undefined;
    finansesDatasetId?: number | undefined;
    incomeAdjustmentsId?: number | undefined;
    lossFactorsId?: number | undefined;
    pvProductionProfileId?: number | undefined;
    windProductionProfileId?: number | undefined;
    otherBessInputId?: number | undefined;
}

export enum CalculationStates {
    NotSet = 0,
    InProgress = 1,
    Finished = 2,
    Error = 3,
    Preprocessing = 4,
    Canceled = 5,
}

export interface ShortResult {
    esAverageCycles?: number | undefined;
    esAverageSoc?: number | undefined;
    irr?: number | undefined;
}

export enum RunOptions {
    None = 0,
    FirstYearOnly = 1,
    FirstAndLastYears = 2,
    AllYears = 3,
    CustomerSelectedYears = 4,
}

export enum SystemConfigurations {
    None = 0,
    Standalone = 1,
    SolarPV = 2,
    SolarPVOnSharedBus = 3,
    WindOnShareBus = 4,
    SolarPVAndAcCoupledWithWind = 5,
    SolarPVAndWind = 6,
}

export enum ScenarioTags {
    Draft = 0,
    Analysis = 1,
    Final = 2,
}

export interface AddDatasetRequest {
    name: string;
}

/** Payload for cloning dataset. */
export interface CloneDatasetRequest {
    /** New dataset name */
    name?: string | undefined;
}

export interface IncomeAdjustmentFactorsSimple extends DatasetSimple {
    fileId?: number | undefined;
    fileName?: string | undefined;
    ownerOrganizationName?: string | undefined;
}

export interface LossFactorsSimple extends DatasetSimple {
    acLineEfficiency?: number | undefined;
    acMainTransformerEfficiency?: number | undefined;
    storageChargeDischargeEfficiency?: number | undefined;
    dcLineEfficiency?: number | undefined;
    dcdcConverterEfficiency?: number | undefined;
    dcacInverterEfficiency?: number | undefined;
    auxiliaryPowerLoss?: number | undefined;
    minimumStateOfCharge?: number | undefined;
    maximumStateOfCharge?: number | undefined;
    initialStateOfCharge?: number | undefined;
    windTotalEfficiency?: number | undefined;
    windAnnualDerating?: number | undefined;
    pvDCACInverterEfficiency?: number | undefined;
    pvAnnualDerating?: number | undefined;
}

export interface UpdateLossFactorsDatasetRequest {
    acLineEfficiency: number;
    acMainTransformerEfficiency: number;
    storageChargeDischargeEfficiency: number;
    dcLineEfficiency: number;
    dcdcConverterEfficiency: number;
    dcacInverterEfficiency: number;
    auxiliaryPowerLoss: number;
    minimumStateOfCharge: number;
    maximumStateOfCharge: number;
    initialStateOfCharge: number;
    windTotalEfficiency?: number | undefined;
    windAnnualDerating?: number | undefined;
    pvDCACInverterEfficiency?: number | undefined;
    pvAnnualDerating?: number | undefined;
}

export interface AddOrganizationRequest {
    name: string;
    description?: string | undefined;
    pricePlanId: number;
    expirationDate: Date;
}

export interface UpdateOrganizationRequest {
    name: string;
    description?: string | undefined;
    pricePlanId: number;
    expirationDate: Date;
}

export interface OtherBessInputsSimple extends DatasetSimple {
    ownerOrganizationName?: string | undefined;
    annualCycleCapFileId?: number | undefined;
    annualCycleCapFileName?: string | undefined;
    augmentationCapacityFileId?: number | undefined;
    augmentationCapacityFileName?: string | undefined;
    capacityRetentionFileId?: number | undefined;
    capacityRetentionFileName?: string | undefined;
    percentageChargingFromRenewableFileId?: number | undefined;
    percentageChargingFromRenewableFileName?: string | undefined;
    shadowPriceFileId?: number | undefined;
    shadowPriceFileName?: string | undefined;
    isShadowPriceChecked: boolean;
}

export interface PortfolioSimple {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    createdBy?: string | undefined;
    createdAt: Date;
    company?: string | undefined;
    projects?: ProjectSimple[] | undefined;
}

export interface ProjectSimple {
    id: number;
    isoBa: IsoBa;
    isoBaName?: string | undefined;
    name?: string | undefined;
    startDate: Date;
    endDate?: Date | undefined;
    scenarios?: ScenarioSimple[] | undefined;
    createdBy?: string | undefined;
    createdAt: Date;
    company?: string | undefined;
    portfolioIds?: number[] | undefined;
}

export enum IsoBa {
    None = 0,
    US_NYISO = 1,
    US_CAISO = 2,
    US_PJM = 3,
    US_MISO = 4,
    US_SPP = 5,
    US_ERCOT = 6,
    US_ISONE = 7,
    CAN_IESO = 8,
    CAN_AESO = 9,
    ES_PENINSULA = 10,
}

export interface AddPortfolioRequest {
    portfolioName: string;
    portfolioDescription?: string | undefined;
}

export interface UpdateLinkedProjectsRequest {
    projectsIds?: number[] | undefined;
}

export interface ProductionProfileSimple extends DatasetSimple {
    sourceType: SourceTypes;
    pvProductionSoftwareType?: PvProductionSoftwareType | undefined;
    productionProfileType: ProductionProfileTypes;
    productionProfileFileId?: number | undefined;
    productionProfileFileName?: string | undefined;
    windAnnualDeratingFileId?: number | undefined;
    windAnnualDeratingFileName?: string | undefined;
    windPTCPriceFileId?: number | undefined;
    windPTCPriceFileName?: string | undefined;
}

export enum SourceTypes {
    Solar = 0,
    Wind = 1,
}

export enum PvProductionSoftwareType {
    Hero = 0,
    Pvsyst = 1,
    SolarFarmer = 2,
    PlantPredict = 3,
    Src = 4,
}

export enum ProductionProfileTypes {
    AnnualProduction = 0,
    Lifetime = 1,
}

export interface Exception {
    targetSite?: MethodBase | undefined;
    message: string;
    data: Data[];
    innerException?: Exception | undefined;
    helpLink?: string | undefined;
    source?: string | undefined;
    hResult: number;
    stackTrace?: string | undefined;
}

export interface HeroException extends Exception {
}

export interface MemberInfo {
    memberType: MemberTypes;
    name: string;
    declaringType?: string | undefined;
    reflectedType?: string | undefined;
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    metadataToken: number;
}

export interface MethodBase extends MemberInfo {
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
}

export enum MethodAttributes {
    PrivateScope = 0,
    ReuseSlot = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    MemberAccessMask = 7,
    UnmanagedExport = 8,
    Static = 16,
    Final = 32,
    Virtual = 64,
    HideBySig = 128,
    NewSlot = 256,
    VtableLayoutMask = 256,
    CheckAccessOnOverride = 512,
    Abstract = 1024,
    SpecialName = 2048,
    RTSpecialName = 4096,
    PinvokeImpl = 8192,
    HasSecurity = 16384,
    RequireSecObject = 32768,
    ReservedMask = 53248,
}

export enum MethodImplAttributes {
    IL = 0,
    Managed = 0,
    Native = 1,
    OPTIL = 2,
    CodeTypeMask = 3,
    Runtime = 3,
    ManagedMask = 4,
    Unmanaged = 4,
    NoInlining = 8,
    ForwardRef = 16,
    Synchronized = 32,
    NoOptimization = 64,
    PreserveSig = 128,
    AggressiveInlining = 256,
    AggressiveOptimization = 512,
    InternalCall = 4096,
    MaxMethodImplVal = 65535,
}

export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export interface RuntimeMethodHandle {
    value: IntPtr;
}

export interface IntPtr {
}

export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

export interface Module {
    assembly: Assembly;
    fullyQualifiedName: string;
    name: string;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export interface Assembly {
    definedTypes: TypeInfo[];
    exportedTypes: string[];
    codeBase?: string | undefined;
    entryPoint?: MethodInfo | undefined;
    fullName?: string | undefined;
    imageRuntimeVersion: string;
    isDynamic: boolean;
    location: string;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[];
    escapedCodeBase: string;
    manifestModule: Module;
    modules: Module[];
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export interface Anonymous {
    genericTypeParameters: string[];
    declaredConstructors: ConstructorInfo[];
    declaredEvents: EventInfo[];
    declaredFields: FieldInfo[];
    declaredMembers: MemberInfo[];
    declaredMethods: MethodInfo[];
    declaredNestedTypes: TypeInfo[];
    declaredProperties: PropertyInfo[];
    implementedInterfaces: string[];
}

export interface TypeInfo extends Anonymous {
}

export interface ConstructorInfo extends MethodBase {
    memberType: MemberTypes;
}

export interface EventInfo extends MemberInfo {
    memberType: MemberTypes;
    attributes: EventAttributes;
    isSpecialName: boolean;
    addMethod?: MethodInfo | undefined;
    removeMethod?: MethodInfo | undefined;
    raiseMethod?: MethodInfo | undefined;
    isMulticast: boolean;
    eventHandlerType?: string | undefined;
}

export enum EventAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
    ReservedMask = 1024,
}

export interface MethodInfo extends MethodBase {
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: string;
    returnTypeCustomAttributes: ICustomAttributeProvider;
    genericParameterCount: number;
}

export interface ParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name?: string | undefined;
    parameterType: string;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export interface CustomAttributeData {
    attributeType: string;
    constructor: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[];
    namedArguments: CustomAttributeNamedArgument[];
}

export interface CustomAttributeTypedArgument {
    argumentType: string;
    value?: any | undefined;
}

export interface CustomAttributeNamedArgument {
    argumentType: string;
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string;
    isField: boolean;
}

export interface ICustomAttributeProvider {
}

export interface FieldInfo extends MemberInfo {
    memberType: MemberTypes;
    attributes: FieldAttributes;
    fieldType: string;
    isInitOnly: boolean;
    isLiteral: boolean;
    isNotSerialized: boolean;
    isPinvokeImpl: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    fieldHandle: RuntimeFieldHandle;
}

export enum FieldAttributes {
    PrivateScope = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    FieldAccessMask = 7,
    Static = 16,
    InitOnly = 32,
    Literal = 64,
    NotSerialized = 128,
    HasFieldRVA = 256,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasFieldMarshal = 4096,
    PinvokeImpl = 8192,
    HasDefault = 32768,
    ReservedMask = 38144,
}

export interface RuntimeFieldHandle {
    value: IntPtr;
}

export interface PropertyInfo extends MemberInfo {
    memberType: MemberTypes;
    propertyType: string;
    attributes: PropertyAttributes;
    isSpecialName: boolean;
    canRead: boolean;
    canWrite: boolean;
    getMethod?: MethodInfo | undefined;
    setMethod?: MethodInfo | undefined;
}

export enum PropertyAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasDefault = 4096,
    Reserved2 = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 62464,
}

export enum SecurityRuleSet {
    None = 0,
    Level1 = 1,
    Level2 = 2,
}

export interface ModuleHandle {
    mdStreamVersion: number;
}

export interface AddProjectRequest {
    projectName?: string | undefined;
    isoBa: IsoBa;
    portfolioIds?: number[] | undefined;
}

/** Model for GetProjectsWithScenariosTree endpoint */
export interface ProjectWithScenarioSimple {
    /** Project Id */
    projectId: number;
    /** Name of project */
    projectName?: string | undefined;
    /** Scenarios in selected project */
    scenarios?: KeyNameSimple[] | undefined;
}

/** Simple key value */
export interface KeyNameSimple {
    /** Element Id */
    id: number;
    /** Name of selected element */
    name?: string | undefined;
}

export interface ReleaseNoteModel {
    major: number;
    minor: number;
    bugFix: number;
    content?: string | undefined;
}

export interface SummaryResult {
    startYear: number;
    endYear?: number | undefined;
    isoBa: IsoBa;
    systemConfiguration: SystemConfigurations;
    systemConfigurationName?: string | undefined;
    interconnectionCapacity?: number | undefined;
    solarPvCapacityDc?: number | undefined;
    inverterCapacityAc?: number | undefined;
    inverterLoadingRatio?: number | undefined;
    bessEnergyCapacityDc?: number | undefined;
    bessEnergyCapacityPoi?: number | undefined;
    bessDuration?: number | undefined;
    minimumSocLimit?: number | undefined;
    maximumSocLimit?: number | undefined;
    dcAcInverterEfficiency?: number | undefined;
    acLossesBetweenPccAndPoi?: number | undefined;
    bessOperatingIncomeResults?: BessOperatingIncomeResult[] | undefined;
}

export interface BessOperatingIncomeResult {
    year: number;
    totalIncome?: number | undefined;
    pvOnlyIncome?: number | undefined;
    esOnlyIncome?: number | undefined;
    usableEnergyAtPoi?: number | undefined;
    equivalentFullCycles?: number | undefined;
    totalEsIncomeKw?: number | undefined;
    pvRevenueLoss?: number | undefined;
    damEnergy?: number | undefined;
    aFrrPower?: number | undefined;
    aFrrEnergy?: number | undefined;
    mFrrEnergy?: number | undefined;
    rtmEnergy?: number | undefined;
    damRegUp?: number | undefined;
    damRegDown?: number | undefined;
    damSr?: number | undefined;
}

export interface BaseScenarioTimeSeriesChartItemSimple {
    timestamp: Date;
    dae: number;
}

export interface CanUsScenarioTimeSeriesChartItemSimple extends BaseScenarioTimeSeriesChartItemSimple {
    dayAheadEnergyPrice: number;
    realTimeEnergyPrice: number;
    regulationDownCapacityPrice: number;
    regulationUpCapacityPrice: number;
    spinningReservePrice: number;
    pvCurtailment: number;
    esCharging: number;
    esDischarging: number;
    windCurtailment: number;
    regulationDownCapacityWhileCharging: number;
    regulationDownCapacityWhileDischarging: number;
    regulationUpCapacityWhileCharging: number;
    regulationUpCapacityWhileDischarging: number;
    spinngingReserveWhileCharging: number;
    spinngingReserveWhileDischarging: number;
    rte: number;
    pvExportToGrid: number;
    windExportToGrid: number;
    maxOutput: number;
    netRegEnergy: number;
    esSoeEndOfInterval: number;
    maxSoe: number;
    esOutputPoi: number;
}

export interface SpainScenarioTimeSeriesChartItemSimple extends BaseScenarioTimeSeriesChartItemSimple {
    aFrrpd: number;
    aFrrpu: number;
    aFrred: number;
    aFrreu: number;
    mFrreu: number;
    mFrred: number;
    pv: number;
    pvClip: number;
    wind: number;
    esCharge: number;
    esDischarge: number;
    esNet: number;
    priceDae: number;
    priceAFrreu?: number | undefined;
    priceAFrred?: number | undefined;
    priceAFrrpu: number;
    priceAFrrpd: number;
    priceMfrreu?: number | undefined;
    priceMfrred?: number | undefined;
    regUpEnToCap: number;
    regDownEnToCap: number;
    lEsEnd: number;
    gGesDa: number;
    gEsgDa: number;
    gPvg: number;
    gPvesGrid: number;
    gPvesClip: number;
    gpvClipDump: number;
    gPvc: number;
    pvAcCapacity?: number | undefined;
}

export interface DispatchResultsSummaryResult {
    date: Date;
    pvResult?: PvResult | undefined;
    bessResults?: BessResultResult | undefined;
    damEnergy?: EnergyMarketResult | undefined;
    rtmEnergy?: EnergyMarketResult | undefined;
    regulationUp?: RegulationMarketResult | undefined;
    regulationDown?: RegulationMarketResult | undefined;
    spinningReserve?: SpinningReserveResult | undefined;
    afrrPowerUp?: AncillaryServicePower | undefined;
    afrrPowerDown?: AncillaryServicePower | undefined;
    afrrEnergyUp?: AncillaryServiceEnergy | undefined;
    afrrEnergyDown?: AncillaryServiceEnergy | undefined;
    mfrrEnergyUp?: AncillaryServiceEnergy | undefined;
    mfrrEnergyDown?: AncillaryServiceEnergy | undefined;
}

export interface PvResult {
    totalDcPvProduction?: number | undefined;
    esDcChargeFromPvClipped?: number | undefined;
    esChargeFromPvNonClipped?: number | undefined;
    inverterClippingDc?: number | undefined;
    economicCurtailmentDc?: number | undefined;
    gridExportDc?: number | undefined;
    gridExportPoi: number;
    pvRevenueOfGridExport?: number | undefined;
    pvRevenueLossDueToEsOperation?: number | undefined;
    totalPvIncomeWithoutEs?: number | undefined;
}

export interface BessResultResult {
    cycle?: number | undefined;
    averageSoc?: number | undefined;
    totalChargeDc?: number | undefined;
    totalDischargeDc?: number | undefined;
    roundTripEfficiencyDc?: number | undefined;
    revenueOfDaEnergy?: number | undefined;
    revenueOfRtEnergy?: number | undefined;
    revenueOfRegUp?: number | undefined;
    revenueOfRegDown?: number | undefined;
    revenueOfSr?: number | undefined;
    pvRevenueLossDueToEsOperation?: number | undefined;
    totalBessIncome?: number | undefined;
    revenueOfAfrrPower: number;
    revenueOfAFrrEnergy: number;
    revenueOfMfrr: number;
}

export interface EnergyMarketResult {
    averageLmpPrice?: number | undefined;
    averageSalePrice?: number | undefined;
    averagePurchasePrice?: number | undefined;
    totalEnergySale?: number | undefined;
    totalEnergyPurchase?: number | undefined;
    revenueOfEnergySale?: number | undefined;
    costOfEnergyPurchase?: number | undefined;
    priceDaeSum?: number | undefined;
    averageEsEnergyCapYear?: number | undefined;
}

export interface RegulationMarketResult {
    averagePrice?: number | undefined;
    averageSalePrice?: number | undefined;
    totalCapacityCommitment?: number | undefined;
    totalEnergyDeployment?: number | undefined;
    revenueOfRegCapacity?: number | undefined;
    revenueOfRegEnergy?: number | undefined;
    revenueOfRegMovement?: number | undefined;
}

export interface SpinningReserveResult {
    averagePrice?: number | undefined;
    averageSalePrice?: number | undefined;
    totalCapacityCommitment?: number | undefined;
    revenueOfSrCapacity?: number | undefined;
}

export interface AncillaryServicePower {
    averagePrice: number;
    averageSalePrice: number;
    totalCapacityCommitment: number;
    revenueValue: number;
}

export interface AncillaryServiceEnergy {
    averagePrice?: number | undefined;
    averageSalePrice?: number | undefined;
    averageActivationRatio: number;
    totalEnergyDeployment: number;
    revenueValue: number;
}

export interface ScenarioCompareDTO {
    scenarioId: number;
    scenarioName?: string | undefined;
    projectName?: string | undefined;
    isoCode: IsoBa;
    selectedRunYears?: number[] | undefined;
    systemConfiguration: SystemConfigurations;
    yearsToRunString?: string | undefined;
    systemConfigurationString?: string | undefined;
    tag: ScenarioTags;
    startYear: number;
    endYear: number;
    irr?: number | undefined;
    term?: number | undefined;
    totalExpenses?: number | undefined;
    totalEarnings?: number | undefined;
    totalProfit?: number | undefined;
    esAverageCycles?: number | undefined;
    esAverageSOC?: number | undefined;
    interconnectionLimit?: number | undefined;
    wholesaleMarketDatasetName?: string | undefined;
    financesDatasetName?: string | undefined;
    incomeAdjustmentDatasetName?: string | undefined;
    lossFactorsDatasetName?: string | undefined;
    productionProfileDatasetName?: string | undefined;
    otherBessInputDatasetName?: string | undefined;
    esPowerCapacity?: number | undefined;
    esEnergyCapacity?: number | undefined;
    maximumDischargePower?: number | undefined;
    pvDcCapacity?: number | undefined;
    pvAcCapacity?: number | undefined;
    pvDcAcInverterEfficiency?: number | undefined;
    pvAnnualDerating?: number | undefined;
    windAcCapacity?: number | undefined;
    windTotalEfficiency?: number | undefined;
    realTimeEnergyParticipationLimit: boolean;
    regulationParticipationLimit: boolean;
    spinningReserveParticipationLimit: boolean;
    projectCost?: ProjectCostRecord | undefined;
    esCost?: EsCostRecord | undefined;
    developmentCost?: DevCostRecord | undefined;
    pvCost?: PvCostRecord | undefined;
    projectCostTotal: number;
    esCostTotal: number;
    developmentCostTotal: number;
    pvCostTotal: number;
}

export interface ProjectCostRecord {
    "Total PV Cost": number;
    "Total Wind Cost": number;
    "Total ES Cost": number;
    "Total Development Cost": number;
    "Total Equip Sales Tax": number;
}

export interface EsCostRecord {
    "DC Side": number;
    "Power Conversion System": number;
    "Grid Management System": number;
    "LV Xmer and Switchgear": number;
}

export interface DevCostRecord {
    "Site Infrastructure": number;
    "Interconnection and Network Upgrade": number;
    "Owner Cost": number;
}

export interface PvCostRecord {
    "Module Equipment": number;
    "Inverter and Control": number;
    "Engg and Construction": number;
    "LV Xmer and Switchgear": number;
}

export interface ScenariosComparisonGroupedAnnuallyDTO {
    year: number;
    cashflow?: CashFlowTableRecord[] | undefined;
    esOperatingCanUsRevenue?: RevenueAnnualCanUsRecord[] | undefined;
    esOperatingSpainRevenue?: RevenueAnnualSpainRecord[] | undefined;
    esOperatingCost?: CostAnnualCanUsRecord[] | undefined;
    resourceIncome?: IncomeAnnualRecord[] | undefined;
}

export interface CashFlowTableRecord {
    Year: number;
    "ES Operating": number;
    "Capacity Market": number;
    "Operating Expenditure": number;
    "Equity Payment": number;
    "Federal ITC Rebate": number;
    "Tax Depreciation": number;
    "ES Pre-Tax Cashflow": number;
    "ES Cumulative Cashflow": number;
    "ES Average Cycles"?: number | undefined;
    "ES Average SOC"?: number | undefined;
    "PV Operating": number;
    "Wind Operating": number;
}

export interface RevenueAnnualCanUsRecord {
    Year?: number | undefined;
    DAE: number;
    RTE: number;
    "Regulation Up": number;
    "Regulation Down": number;
    "Spinning Reserve": number;
    Total: number;
}

export interface RevenueAnnualSpainRecord {
    Year?: number | undefined;
    DAE: number;
    mFRRU: number;
    aFRRU: number;
    aFRRD: number;
    mFRRD: number;
    Total: number;
}

export interface CostAnnualCanUsRecord {
    Year: number;
    DAE: number;
    RTE: number;
    PV: number;
    Wind: number;
    Total: number;
}

export interface IncomeAnnualRecord {
    "ES Operating Income": number;
    "PV Operating Income": number;
    "Wind Operating Income": number;
    Year: number;
}

export interface ConstraintDefinitionSimple {
    scenarioId: number;
    marketProductType: DatasetFileTypes;
    years?: number[] | undefined;
    isCharging: boolean;
    isBusinessDay: boolean;
    constraints?: number[][] | undefined;
}

export enum DatasetFileTypes {
    NotSet = 0,
    DayAheadEnergyPrices = 1,
    RealTimeEnergyPrice = 2,
    RegUpPrices = 3,
    RegDownPrices = 4,
    SpinningReservePrices = 5,
    RegulationMileagePrice = 6,
    CapacityMarketPrice = 7,
    CapacityAugmentation = 8,
    IncomeAdjustmentFactors = 9,
    ProductionProfile = 10,
    WindAnnualDerating = 11,
    WindPTCPrice = 12,
    PercentageChargingFromRenewable = 13,
    AugmentationCapacity = 14,
    AnnualCycleCap = 15,
    ShadowPrice = 16,
    CapacityRetention = 17,
    AFRREnergyDown = 18,
    AFRREnergyUp = 19,
    AFRRPower = 20,
    MFRREnergyDown = 21,
    MFRREnergyUp = 22,
    REEDayAheadEnergyPrice = 23,
}

export interface SetConstraintDefinitionRequest {
    marketProductType: DatasetFileTypes;
    years?: number[] | undefined;
    isBusinessDay: boolean;
    isCharging: boolean;
    constraints?: number[][] | undefined;
}

export interface ScenarioDetailed extends ScenarioSimple {
    isoBa: IsoBa;
    isoBaName?: string | undefined;
    storage?: StorageSimple | undefined;
    photovoltaic?: PhotovoltaicSimple | undefined;
    wind?: WindSimple | undefined;
    energyCapacityAtPoi?: number | undefined;
    acMediumVoltageTransformerEfficiency: number;
    installedPowerCapacity: number;
    defaultAcLineEfficiency?: number | undefined;
    defaultAcMainTransformerEfficiency?: number | undefined;
    defaultStorageChargeDischargeEfficiency?: number | undefined;
    defaultDCLineEfficiency?: number | undefined;
    defaultDCDCConverterEfficiency?: number | undefined;
    defaultAuxiliaryPowerLoss?: number | undefined;
    defaultDCACInverterEfficiency?: number | undefined;
    defaultInitialStateOfCharge?: number | undefined;
    defaultMaximumStateOfCharge?: number | undefined;
    defaultPvDcAcInverterEfficiency?: number | undefined;
    defaultPvAnnualDerating?: number | undefined;
    defaultWindACCapacity?: number | undefined;
}

export interface StorageSimple {
    inverterPowerCapacity?: number | undefined;
    installedEnergyCapacity?: number | undefined;
    contractedEnergyCapacity?: number | undefined;
    storageMaxDischargePower?: number | undefined;
    storageMaxChargePower?: number | undefined;
    storageChargeDischargeEfficiency?: number | undefined;
    dcLineEfficiency?: number | undefined;
    dcdcConverterEfficiency?: number | undefined;
    auxiliaryPowerLoss?: number | undefined;
    dcacInverterEfficiency?: number | undefined;
    minimumStateOfCharge?: number | undefined;
    maximumStateOfCharge?: number | undefined;
    initialStateOfCharge?: number | undefined;
    maxDischargePowerForRegulationUp?: number | undefined;
    maxChargePowerForRegulationDown?: number | undefined;
    maxDischargePowerForSpin?: number | undefined;
    percentageChargingFromRenewableFileId?: number | undefined;
    percentageChargingFromRenewableFileName?: string | undefined;
    shadowPriceFileId?: number | undefined;
    shadowPriceFileName?: string | undefined;
    stateOfHealthFileId?: number | undefined;
    stateOfHealthFileName?: string | undefined;
    augmentationCapacityFileId?: number | undefined;
    augmentationCapacityFileName?: string | undefined;
    annualCycleCapFileId?: number | undefined;
    annualCycleCapFileName?: string | undefined;
}

export interface PhotovoltaicSimple {
    dcCapacity?: number | undefined;
    acCapacity?: number | undefined;
    annualDerating?: number | undefined;
    dcacInverterEfficiency?: number | undefined;
    pvesComInsCap?: number | undefined;
    pvdcLineEffOW?: number | undefined;
    pvdcConvEffOW?: number | undefined;
    pvacInvEffOW?: number | undefined;
    pvProductionProfileFileId?: number | undefined;
    pvProductionProfileFileName?: string | undefined;
    isLifetimeProductionProfile: boolean;
    pvLifetimeProductionProfileId?: string | undefined;
    pvLifetimeProductionProfileName?: string | undefined;
}

export interface WindSimple {
    acCapacity?: number | undefined;
    totalEfficiency?: number | undefined;
    windProductionProfileFileId?: number | undefined;
    windProductionProfileFileName?: string | undefined;
    windClippingProfileFileId?: number | undefined;
    windClippingProfileFileName?: string | undefined;
    isLifetimeProductionProfile: boolean;
    windLifetimeProductionProfileFileId?: number | undefined;
    windLifetimeProductionProfileFileName?: string | undefined;
    annualDeratingFileId?: number | undefined;
    annualDeratingFileName?: string | undefined;
}

export interface AddScenarioRequest {
    projectId: number;
    name?: string | undefined;
}

export interface GetCalculationProgressResponse {
    isCalculating: boolean;
    message?: string | undefined;
    progress: number;
    preprocessingProgress: number;
}

/** Request for cloning existing scenario. */
export interface CloneScenarioRequest {
    /** Name for new Scenario (existing scenario will to be cloned) */
    name?: string | undefined;
}

export interface PredictionLogResponseItem {
    projectId: number;
    scenarioId: number;
    calculationId: number;
    calculationState: CalculationStates;
    projectName?: string | undefined;
    scenarioName?: string | undefined;
    runDate: Date;
    finishedDate?: Date | undefined;
}

export interface PredictionLogRequest {
    pageNumber: number;
    pageCount: number;
    filterText?: string | undefined;
}

export interface UserSimple {
    id: string;
    userName?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    veracityAlias?: string | undefined;
    organizationId?: number | undefined;
    isEnabled: boolean;
    isApiKeyActive: boolean;
    organization?: OrganizationSimple | undefined;
    roleId: number;
    roleName?: string | undefined;
}

export interface WholesaleMarketSimple extends DatasetSimple {
    isoBaItems?: IsoBa[] | undefined;
}

export interface WholesaleMarketDatasetWithFilesSimple extends DatasetSimple {
    dayAheadEnergyPricesFile?: WholesaleMarketDatasetFileInfo | undefined;
    realTimeEnergyPriceFile?: WholesaleMarketDatasetFileInfo | undefined;
    regUpPricesFile?: WholesaleMarketDatasetFileInfo | undefined;
    regDownPricesFile?: WholesaleMarketDatasetFileInfo | undefined;
    spinningReservePricesFile?: WholesaleMarketDatasetFileInfo | undefined;
    regulationMileagePriceFile?: WholesaleMarketDatasetFileInfo | undefined;
    capacityMarketPriceFile?: WholesaleMarketDatasetFileInfo | undefined;
    afrrEnergyDownFile?: WholesaleMarketDatasetFileInfo | undefined;
    afrrEnergyUpFile?: WholesaleMarketDatasetFileInfo | undefined;
    afrrPowerFile?: WholesaleMarketDatasetFileInfo | undefined;
    mfrrEnergyDownFile?: WholesaleMarketDatasetFileInfo | undefined;
    mfrrEnergyUpFile?: WholesaleMarketDatasetFileInfo | undefined;
    reeDayAheadEnergyPricesFile?: WholesaleMarketDatasetFileInfo | undefined;
    createdById: string;
    ownerName?: string | undefined;
    ownerOrganizationName?: string | undefined;
    linkedScenarios?: ScenarioSimple[] | undefined;
    isoBaItems?: IsoBa[] | undefined;
    datasetProvider: WholesaleMarketProviders;
    customPriceProviderName?: string | undefined;
}

export interface WholesaleMarketDatasetFileInfo {
    id?: number | undefined;
    name?: string | undefined;
}

export enum WholesaleMarketProviders {
    DNV = 0,
    Other = 2147483647,
}

export interface AddWholesaleMarketDatasetRequest extends AddDatasetRequest {
    isoBaItems: IsoBa[];
    datasetProvider?: WholesaleMarketProviders | undefined;
    customPriceProviderName?: string | undefined;
}

export interface Data {

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}